<template>
  <div>
    <div id="hpc">
      <div id="lbimg"><img style="width: 100%;height: 100%;" src="../assets/img/tout/gy.jpg"></div>
      <div id="aTow">
        <div id="navContents">
          <div id="navBtn">
            <div>
              <router-link tag="div" id="nav1" :to="{path:'/about/introduction'}"><span id="text1">青博介绍</span></router-link>
              <router-link tag="div" id="nav2" :to="{path:'/about/qbconstitution'}"><span id="text2">青博章程</span></router-link>
              <router-link tag="div" id="nav3" :to="{path:'/about/contact'}"><span id="text3">交通指南</span></router-link>
              <!--<router-link tag="div" id="nav3" :to="{path:'/about/organization'}"><span id="text3">组织机构</span></router-link>-->
              <router-link tag="div" id="nav4" :to="{path:'/about/talent'}"><span id="text4">人才招聘</span></router-link>
              <!--<router-link tag="div" id="nav6" :to="{path:'/about/contact'}"><span id="text6">联系我们</span></router-link>-->
            </div>
            <div id="imgss"><img style="width: 100%;" src="../assets/img/nb.png"></div>
            <div id="daolan">
              <p>游览须知</p>
              <p>开放时间:周二至周日9:00-17:00(16:30停止入场)法定节假日无特殊情况正常开放，逢周一闭馆，节假日及其他重要活动等特殊情况将提前公告开放时间。参观咨询电话:0971-6111326</p>
              <p style="color: #FF4500;">温馨提示：参观人员均需凭预约码入馆</p>
            </div>
            <router-link tag="div" id="defdl" :to="{path:'/about/tourguide'}">进入游览详情</router-link>
          </div>
          <div id="eCon">
            <router-view></router-view>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <div id="hmobile">
      <div style="width: 100%;height: 150px;"><img style="width: 100%;height: 100%;" src="../assets/img/tout/gy.jpg"></div>
      <div id="maTow">
        <div id="mnavContents">
          <div id="mnavBtn">
            <div>
              <router-link tag="div" id="mnav1" :to="{path:'/about/introduction'}"><span id="mtext1">青博介绍</span></router-link>
              <router-link tag="div" id="mnav2" :to="{path:'/about/qbconstitution'}"><span id="mtext2">青博章程</span></router-link>
              <router-link tag="div" id="mnav3" :to="{path:'/about/contact'}"><span id="mtext3">交通指南</span></router-link>
            </div>
          </div>
          <div id="meCon">
            <router-view></router-view>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {}
    },
    methods: {
      handleSearch() {
        let eWidth = document.body.clientWidth;
        document.getElementById("hpc").style.width = eWidth + "px";
        document.getElementById("aTow").style.marginLeft = (eWidth - eWidth * 0.9) / 2 + "px";
        document.getElementById("aTow").style.marginRight = (eWidth - eWidth * 0.9) / 2 + "px";
        document.getElementById("lbimg").style.width = eWidth + "px";
        document.getElementById("lbimg").style.height = eWidth * 0.35 + "px";
        document.getElementById("eCon").style.width = eWidth * 0.72 + "px";
        document.getElementById("navBtn").style.width = eWidth * 0.18 + "px";
        document.getElementById("navContents").style.width = eWidth * 0.9 + "px";
        document.getElementById("navContents").style.marginTop = "20px";
        for (var i = 1; i < 5; i++) {
          document.getElementById("nav" + i + "").style.width = eWidth * 0.18 + "px";
          document.getElementById("nav" + i + "").style.height = (eWidth * 0.18) / 5 + 17 + "px";
          document.getElementById("text" + i + "").style.top = ((eWidth * 0.18) / 5 - 13) / 2 + "px";
        };
        document.getElementById("imgss").style.width = eWidth * 0.18 + "px";
        document.getElementById("imgss").style.marginTop = "10px";
        document.getElementById("daolan").style.width = eWidth * 0.18 + "px";
        document.getElementById("daolan").style.textAlign = "left";
      },
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("hmobile").style.display = "block";
      } else {
        document.getElementById("hpc").style.display = "block";
        this.handleSearch();
      };
      $("body,html").animate({
        scrollTop: 0
      }, 1);
    }
  }
</script>

<style scoped>
  #hpc {
    display: none;
    background: rgba(255, 255, 255, 0.6);
  }

  #hpc>#aTow>#aNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #hpc>#aTow>#aNav>span:nth-child(1) {
    cursor: pointer;
  }

  #hpc>#aTow>#aNav>span:nth-child(1):hover {
    color: #FF9900;
  }

  #hpc>#aTow>div:nth-child(1)>img {
    width: 100%;
    height: 100%;
  }

  #hpc>#aTow>div:nth-child(1)>span {
    width: 380px;
    height: 150px;
    font-size: 50px;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1) {
    float: left;
  }

  #eCon {
    float: left;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(1) {
    cursor: pointer;
    color: rgb(176, 153, 138);
    background-image: url(../assets/navback/navback-1.png);
    border-bottom: 1px solid #FFFFFF;
    position: relative;
    background-size: cover;
  }

  #nav1>span,
  #nav2>span,
  #nav3>span,
  #nav4>span,
  #nav5>span,
  #nav6>span,
  #nav7>span,
  #nav8>span {
    position: absolute;
    left: 0;
    right: 0;
    line-height: 30px;
    font-size: 1.3em;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(2) {
    cursor: pointer;
    color: rgb(176, 153, 138);
    background-image: url(../assets/navback/navback-2.png);
    border-bottom: 1px solid #FFFFFF;
    position: relative;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(3) {
    cursor: pointer;
    color: rgb(176, 153, 138);
    background-image: url(../assets/navback/navback-3.png);
    border-bottom: 1px solid #FFFFFF;
    position: relative;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(4) {
    cursor: pointer;
    color: rgb(176, 153, 138);
    background-image: url(../assets/navback/navback-4.png);
    border-bottom: 1px solid #FFFFFF;
    position: relative;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(1):hover {
    background-image: url(../assets/navback/q2navback1.png);
    color: white;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(2):hover {
    background-image: url(../assets/navback/q2navback2.png);
    color: white;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(3):hover {
    background-image: url(../assets/navback/q2navback3.png);
    color: white;
    background-size: cover;
  }

  #hpc>#aTow>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>div:nth-child(4):hover {
    background-image: url(../assets/navback/q2navback4.png);
    color: white;
    background-size: cover;
  }

  #cContent>#aTow>div:nth-child(2)>div:nth-child(1)>div:nth-child(2) {
    width: 82%;
    float: left;
  }

  #cContent>#aTow>div:nth-child(2)>div:nth-child(1)>div:nth-child(2) {
    width: 100%;
    height: 120px;
    background: #A9A9A9;
    margin-top: 10px;
  }

  #cContent>#aTow>div:nth-child(3)>div:nth-child(1)>div:nth-child(3) {
    width: 100%;
    margin-top: 135px;
    text-align: left;
    line-height: 30px;
    border-radius: 1px solid #A9A9A9;
  }

  #cContent>#aTow>div:nth-child(3)>div:nth-child(1)>div:nth-child(4) {
    width: 100%;
    margin-top: 135px;
    text-align: left;
    line-height: 30px;
    border-radius: 1px solid #A9A9A9;
  }

  p {
    margin: 0;
    line-height: 30px;
  }

  #defdl {
    width: 60%;
    height: 30px;
    margin: 20px 20%;
    background: #FF9900;
    line-height: 30px;
    cursor: pointer;
    color: #ffffff;
  }

  #defdl:hover {
    background: #FF0000;
  }

  /*mobile*/
  #hmobile {
    display: none;
    background: rgba(255, 255, 255, 0.6);
  }

  #mnavBtn {
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #956f17;
  }

  #mnavBtn>div>div {
    width: 33.3%;
    height: 100%;
    line-height: 60px;
    color: #956f17;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Aboutqb.vue